export const INIT_USERS_LIST = '[USERS][INIT][LIST]';
export const GET_USERS_SUCCESS = '[USERS][GET][SUCCESS]';
export const GET_USERS_ENGAGEMENT_OPTIONS_SUCCESS = '[USERS][GET][ENGAGEMENT][OPTIONS][SUCCESS]';
export const USERDETAIL_FORM_ATTR = '[USERDETAIL][FORM_ATTR][SUCCESS]';
export const GET_COUNTRYLIST_SUCCESS = '[USERDETAIL][GET_COUNTRY_LIST]';
export const RESET_USERDETAIL_OBJECT = '[USERDETAIL][RESET_OBJECT]';
export const SET_SYSTEM_ROLES = '[SYSTEMROLES][SET_ARRAY]';
export const SET_USERDETAIL_OBJECT = '[USERDETAIL][SET_OBJECT]';
export const SET_USERS_DETAIL_ENGAGEMENTS = '[USERDETAIL][SET_ENGAGEMENTS]';



// WEBPACK FOOTER //
// ./src/ui/features/Users/state/usersTypes.js